export default {
  "pet": "Pet",
  "pets": "Pets",
  "processing_fee_notice_mainpage": "A small payment gateway processing fee may apply.",
  "convenience_fee": "Convenience Fee",
  "processing_fee_notice": "Payment processing charges of 2.5% will be deducted from the refund for online payments.",
  "cancel_booking_request": "Cancel Booking Request",
  "existing_booking_cancel_request": "Have an existing booking request that you want to cancel?",
  "best_invitational_price_ever": "Best invitational price ever",
  "arrival_request": "Arrival Request",
  "departure_request": "Departure Request",
  "modify_booking_title": "Modify Booking",
  "cancel_booking_title": "Cancel Booking",
  "Available": "Available",
  "Promotion_Applied": "Promotion Applied",
  "Maximum room count reached!": "Maximum room count reached!",
  "select_room": "Select Room",
  "booking_summary": "Booking Summary",
  "your_stay": "Your Stay",
  "filters": "Filters",
  "apply": "Apply",
  "no_rooms_selected_yet": "No rooms selected yet",
  "pick_rate_plan_hint": "Choose a room to continue your booking.",
  "see_rooms": "See rooms",
  "change_dates": "Change dates",
  "add_room": "Add room",
  "remove_room": "Remove room",
  "increase": "Increase",
  "decrease": "Decrease",
  "offer": "Offer",
  "property": "Property",
  "full_night_booking": "Full Night Booking",
  "hourly_booking": "Hourly Booking",
  "unlock": "Unlock",
  "remove": "Remove",
  "bed": "Bed",
  "beds": "Beds",
  "room": "Room",
  "night": "Night",
  "guests": "Guests",
  "guest": "Guest",
  "hour": "Hour",
  "addons": "Addons",
  "addons_subheading": "Make your stay more comfortable",
  "discount": "Discount",
  "get_property_website": "Click here to get your property website",
  "unlock_additional_discount": "Unlock Additional 15% OFF!",
  "code_mount_applied": "Code MOUNT Applied",
  "you_save": "You Save",
  "additional_15_off": "Additional Offer",
  "final_price": "Final Price",
  "taxes": "Taxes",
  "book_now": "Book Now",
  "hello_there": "Hello There!",
  "im": "I'm",
  "travel_dates_and_guests": "Travel dates and guests",
  "your_host": "your host.",
  "overview": "Overview",
  "rooms": "Rooms",
  "faqs": "FAQs",
  "reviews": "Reviews",
  "show_more": "Show more",
  "show_all": "Show all",
  "map": "Map",
  "facilities": "Facilities",
  "unmarried_couples_not_allowed": "Unmarried couples are not allowed.",
  "amenities": "Amenities",
  "introducing_hourly_stays": "Introducing Hourly Stays!",
  "show_less": "Show less",
  "book_for": "Book for",
  "best_service_offers": "Book directly with us for best service and offers!",
  "about_us": "About Us",
  "book_for_full_night": "Book For Full Night",
  "weather_at_hotel": "Weather at Hotel",
  "checkin_forecast": "Check-in Day Forecast",
  "nearby_places": "Nearby Places",
  "nearby_hotels_available": "Nearby Hotels Available",
  "nearby_hotels_description": "Check out these nearby properties with availability for your dates",
  "nearby_hotels_oops_title": "Oops! Fully booked for those dates",
  "nearby_hotels_oops_subtitle": "Don't worry - we found great alternatives nearby!",
  "view_availability": "View Rooms",
  "view_in_maps": "View in Maps",
  "couple_friendly": "Couple Friendly. Experience a safe and intimate stay.",
  "slay_travel_itinerary": "Time to slay that travel itinerary",
  "generate_in_seconds": "Generate one in seconds",
  "cancel_booking": "Cancel your Booking",
  "verify": "Verify",
  "amount_paid": "Amount Paid",
  "total_amount": "Total Amount",
  "cancel_confirmation": "Are you sure you want to cancel?",
  "refund_amount": "Refund Amount",
  "no_option": "No",
  "no_booking_found": "Sorry, We didn't find any booking for this number",
  "yes_option": "Yes",
  "have_booking_changes": "Have a booking you want to make changes to?",
  "manage_booking": "Manage Booking",
  "manage_booking_hint": "Enter the details from your booking confirmation.",
  "enter_phone": "Please enter phone number",
  "enter_booking_id": "Please enter booking id",
  "what_would_you_like": "What would you like to do?",
  "modify_booking": "Modify Booking",
  "booking_id": "Booking ID",
  "verifying": "Verifying...",
  "cancelling": "Cancelling...",
  "processing": "Processing...",
  "enter_booking_details": "Enter your booking details",
  "phone_number": "Phone Number",
  "enter_valid_phone": "Please enter a valid phone number",
  "enter_booking_id_error": "Please enter your booking ID",
  "cancel": "Cancel",
  "modify": "Modify",
  "property_rules_title": "Property Rules",
  "selected_date": "Selected Date",
  "select": "Select",
  "faq_title": "Frequently Asked Questions",
  "existing_booking_cancel": "Have an existing booking that you want to cancel?",
  "cancellation_refund_policy": "Refund Policy",
  "if_cancelled": "If cancelled",
  "deducted": "is charged for",
  "free_cancellation": "Free Cancellation Available",
  "follow_us_on": "Follow us on",
  "offer_ends_soon": "Offer Ends Soon, Book now to avail the offer",
  "continue": "Continue",
  "checkin_date_time": "Checkin Date - Checkin Time",
  "checkin_checkout": "Checkin - Checkout",
  "not_available_selected_checkin_time": "Not available for the selected checkin time",
  "please_select_time_slot": "Please select time slot",
  "reserve": "Reserve",
  "adult_age": "18yrs and above",
  "adults": "Adults",
  "years": "years",
  "children": "Children",
  "infants": "Infants",
  "selected_for": "Selected for",
  "maximum_occupancy_reached": "Maximum occupancy reached, Select extra room.",
  "guest_select_stay_for_other": "guest, please select stay for other",
  "extra_adult": "Extra Adult",
  "extra_child": "Extra Child",
  "price_for_upto": "Price for up to",
  "price_for": "Price for",
  "max_bed": "Max Bed",
  "bed_dorm": "Bed Dorm",
  "additional_guests": "Additional Guests (chargeable)",
  "max": "Max",
  "max_pax": "Max Pax",
  "included": "Included",
  "free": "Free",
  "verified": "Verified",
  "can_stay_for_free": "can stay for free",
  "lowest_price_ever": "Lowest Price Ever",
  "recommended": "Recommended",
  "min_pax": "Min Pax",
  "free_cancellation_till": "Free Cancellation till",
  "book_now_pay_later": "Book Now Pay Later",
  "reserve_at_just": "Reserve at just",
  "sold_out": "Sold Out",
  "room_left_hurry_up": "Room left, Hurry Up!",
  "rooms_left_hurry_up": "Rooms left, Hurry Up!",
  "off": "OFF",
  "incl_of_taxes": "Incl of Taxes",
  "view_more": "View more",
  "select_rooms": "Select Rooms",
  "add": "Add",
  "enter_email_address": "Please Enter Email Address",
  "view_room": "View Room",
  "selected": "Selected",
  "person": "Person",
  "enter_valid_email_address": "Please Enter Valid Email Address",
  "day": "Day",
  "enter_name": "Please Enter Valid Name",
  "enter_all_details": "Please enter all the details",
  "please_select_payment_method": "Please select payment method",
  "try_again_later": "Please try again later!",
  "thank_you_response": "Thank you for your response :)",
  "checkout_summary": "Checkout summary",
  "check_in": "Check-In",
  "room_and_guests": "Room and Guests",
  "check_out": "Check-out",
  "secured_by": "Secured by",
  "more": "& more",
  "pay_at_property": "Pay At Property",
  "pay_just": "Pay just",
  "pay_full_amount": "Pay full amount",
  "to_book": "to book",
  "cancel_booking_prompt": "Want to modify / cancel the booking?",
  "bill_details": "Bill Details",
  "additional_discount": "Additional Discount",
  "select_payment_method": "Select Payment Method",
  "cashback_offer": "Cashback up to ₹50 on online payments",
  "add_reason_suggestions": "Please add your reason/suggestions",
  "hurry_up_discount_expires_in": "Hurry Up! Additional Discount Expires in",
  "selected_rooms": "Selected Rooms",
  "pax_but_rooms_selected_for_only": "pax but rooms are selected for only",
  "you_have_searched_for": "You've searched for",
  "note": "Note:",
  "please_book_extra_rooms_for_other": "Please book extra rooms for other",
  "traveller_details": " Traveller",
  "contact_number": "Contact number",
  "enter_contact_number": "Enter Contact Number",
  "full_name": "Full name",
  "enter_traveller_name": "Enter Traveller Name",
  "enter_age": "Enter Age",
  "enter_email_id": "Email",
  "estimated_arrival_time": "Estimated Arrival Time",
  "enter_email": "Enter Email",
  "type_your_requests_here": "Type your requests here",
  "add_special_requests": "Add Special Requests",
  "we_also_provide": "We also provide",
  "cancellation_policy": "Cancellation Policy",
  "date": "Date",
  "refund": "Refund",
  "refund_policy_description": "If the amount paid is less than the refund amount, no refund will be issued upon cancellation. Refund may take up to 4-5 business days to process.",
  "before": "Before",
  "why_book_direct": "Why Book Direct?",
  "disclaimer": "Disclaimer",
  "what_went_wrong": "What went wrong?",
  "payment_options_message": "We provide all types of payment options including EMIs and wallets just like any other platform",
  "booking_directly_message": "Booking directly with us saves on commissions lost, directly benefiting our property and staff who are the backbone of small businesses",
  "book_directly_message": "Book directly with us to get best service quality",
  "share_feedback": "Share feedback for a chance to",
  "additional_discount_expires_in": "Additional Discount Expires in",
  "win_voucher": "win an Amazon voucher worth ₹500",
  "improvement_feedback": "Let us know how to improve",
  "limited_offer": "Limited Offer!",
  "click_here": "Click Here Now!",
  "hourly_room_booking": "Hourly Room Booking",
  "no_waiting_just_go": "No waiting, just go!",
  "instant_confirmation": "Instant Confirmation",
  "on_bookings_above": "On bookings above",
  "and": "and",
  "get": "get",
  "flat": "FLAT",
  "and_get": "and get",
  "early_bird_offer": "Early Bird Offer",
  "use_code": "Use Code",
  "book": "Book",
  "last_minute_deals": "Last Minute Deals",
  "days_advance": "days advance",
  "book_now_for": "Book Now for",
  "go_back": "Go Back",
  "room_details": "Room Details",
  "page_not_found": "Page Not Found",
  "above_12_years_age": "Above 12 years of Age",
  "select_guests": "Select Guests",
  "below_12_years_age": "Below 12 years of Age",
  "done": "Done",
  "fill_details_generate_itinerary": "Fill in the following details to generate a personalised travel itinerary for your trip",
  "plan_up_to_3_days": "You can only plan up to 3 days",
  "fill_all_details": "Please fill all the details",
  "maximum_additional_guest": "Maximum additional guest:",
  "room_minimum_capacity": "Room minimum capacity:",
  "no_worries_cancel": "No worries. Cancel hassle-free.",
  "flexible_hassle_free_affordable": "Flexible. Hassle-free. Affordable.",
  "wait_create_itinerary": "Please wait while we create your personalised travel itinerary",
  "generate_travel_itinerary": "Generate Travel Itinerary",
  "total": "Total",
  "secured_payments": "100% secured payments",
  "email": "Email",
  "generate_itinerary": "Generate Itinerary",
  "planning_days": "How many days are you planning for?",
  "enter_number_of_days": "Enter number of days",
  "purpose_of_visit": "What is the purpose of the visit?",
  "visit_purposes": "Vacation, Leisure, Culinary Delights etc",
  "personalized_itinerary": "Here's your personalized trip itinerary",
  "book_now_savor_itinerary": "Book now, savor the itinerary!",
  "book_direct_best_price_service": "Book Direct: Best Price, Exceptional Service.",
  "subscribe_now_to": "Subscribe now to",
  "get_extra": "Get extra",
  "subscribe": "Subscribe",
  "no_thanks": "No, Thanks!",
  "add_for": "Add for",
  "is_selected_for": "is selected for",
  "days": "days",
  "powered_by": "Powered by",
  "copyrights": "Copyrights",
  "privacy_policy": "Privacy Policy",
  "terms_and_conditions": "Terms and Conditions",
  "made_with_love_in_india": "Made with ❤️ in India",
  "all_rights_reserved": "All Rights Reserved",
  "please_reach_us_at": "Please reach us at",
  "ask_a_question": "Ask a Question?",
  "applied": "Applied",
  "for": "for",
  "enter_valid_phone_number": "Enter valid phone number",
  "upto": "Up to",
  "nights": "nights",
  "per_night": "per night",
  "per": "per",
  "no_cost_emi_from": "Bajaj No Cost EMI starts at",
  "per_month_star": "/month*",
  "booking_support_local": "By booking directly, you support our local hotel and the community. Join us in making a positive impact and experience genuine local hospitality.",
  "you_got": "You got",
  "enhanced_experience": "Enhanced Experience",
  "first_choice_preference": "First Choice Preference",
  "book_directly_lowest_rates": "Book directly for our lowest rates, guaranteed. Get the best value for your money by reserving through our website.",
  "booking_directly_saves": "By booking directly with us, we can save on the 20% commission charges and hence provide you a better experience.",
  "book_directly_hassle_free": "Book directly with our official hotel website for a hassle-free experience and unmatched benefits!",
  "best_price_guarantee": "Best Price Guarantee",
  "support_local_businesses": "Support Local Businesses",
  "booking_benefits": "Benefits of Booking from our Official Website",
  "please_enter_your_question": "Please enter your question",
  "select_at_least_one_room": "Please select at least one room",
  "additional_15_percent_off_applied": "Additional 15% OFF applied!",
  "book_direct_choose_room": "Book directly for the privilege of choosing your ideal room first.",
  "lets_book": "Let's Book",
  "help_us_know_more": "Help us know more!",
  "get_best_price": "Get Best Price!",
  "submit": "Submit",
  "on_google": "on Google",
  "check_inbox_spam_folder": "If the hotel does not confirm your booking within 30 minutes, please contact the hotel's reception directly using the phone number or email address provided below. The hotel team will be happy to assist you with your booking confirmation.",
  "better_price_elsewhere": "Found a better price elsewhere?",
  "share_details_best_deal": "Share your details for the best deal! Our team will reach out.",
  "best_price_guarantee_chat": "Video call to see your room!",
  "apology_incorrect_price": "We sincerely apologize for the inconvenience caused by the incorrect price displayed for your booking on our website. It was an unfortunate occurrence due to high demand and a technical glitch. We deeply regret any inconvenience caused and want to make things right for you",
  "booking_cancelled_successfully": "Booking Cancelled Successfully",
  "where_lower_price": "Where did you come across the lower price?",
  "booking_request_received": "We have received your booking request!",
  "complete_booking": "We are holding your room!",
  "booking_confirmed": "Booking Confirmed!",
  "booking_rejected": "Booking Rejected!",
  "booking_cancelled": "Booking Cancelled!",
  "your_reservation_has_been_marked_no_show_by_the_property": "Your reservation has been marked as \"No Show\" by the property.",
  "waiting_to_host_your_stay": "Please complete the booking :)",
  "enjoy_your_stay": "Congratulations! Enjoy your stay :)",
  "stays_not_available": "Sorry, Stays are not available for the selected days.",
  "booking_cancelled_message": "You've cancelled your booking",
  "refund_initiated": "Refund is initiated. (If Applicable)",
  "booking_cancelled_notification": "Your booking has been cancelled",
  "refund_initiated_notification": "and refund is initiated. (If Applicable)",
  "booking_details": "Booking Details",
  "contact_us": "Contact Us",
  "room_and_guest": "ROOM & GUEST",
  "child": "Child",
  "adult": "Adult",
  "infant": "Infant",
  "payment_status": "PAYMENT STATUS",
  "decline_price_refund_note": "Note: If you decide to decline the revised price, we will process a refund for any amount you have already paid within 3-5 working days.",
  "view_details": "View Details",
  "updated_price": "Updated Price",
  "amount_to_pay": "Amount To Pay (Incl. of all taxes)",
  "advance_paid": "Advance Paid",
  "location": "Location",
  "open_in_maps": "Open in Maps",
  "payment_options": "Payment Options",
  "now_to_reserve": "now to reserve",
  "reject_action": "Reject",
  "call_hotel": "Call Hotel",
  "accept_action": "Accept",
  "complete_bookings": "Complete Booking",
  "go_home": "Go Home",
  "refund_details": "Refund Details",
  "disclaimer_text": "Hotelzify Private Limited (“Hotelzify”) generates and maintains this Website on behalf of the Property and merely enables technological support for booking a particular property. All information available on the Website is as per the information provided by the Property to Hotelzify and is for reference only. Any discrepancies, or costs, losses, damages, lawsuits, deficiencies, claims and expenses (including court costs and reasonable attorney’s fees) in connection with or arising out of or resulting from or incidental to this Website or bookings made on it, shall be raised by the User with the Property directly. Hotelzify will have no responsibility in the process of resolution, and shall not take any liability for such discrepancies and/or losses.",
  "age_optional": "Age (optional)",
  "payment_methods": "Select Mode Of Payment",
  "proceed": "Proceed",
  "change_language": "Change Language",
  "booking_expired_or_not_exist": "Booking is either expired or does not exist. Please try creating a booking again.",
  "invalid_date_redirect": "Invalid Date! Redirecting to home page",
  "cashback_offer_mobiqwik": "Assured ₹10-50 Cashback!",
  "use_mobikwik": "Extra Discount via Mobikwik",
  "Video call to see your room": "Video call to see your room",
  "Call Property": "Call Property",
  "In case of No Show / Cancelling on day of Check-in will incur": "In case of No Show / Cancelling on day of Check-in will incur",
  "penalty": "penalty",
  "Cancelling": "Cancelling",
  "before arrival incurs a": "before arrival incurs a",
  "no_refund": "No refund",
  "of_the_booking_amount": "of the booking amount",
  "cancellation_are_only_allowed_before_checkin_time_all_the_time_mentioned_above_is_in_destination_time": "Cancellations are only allowed before check-in time, based on the property's local time.",
  "free_cancellation_100_refund_if_you_cancel_this_booking_before": "Free cancellation (100% refund) if you cancel this booking before ",
  "free_cancellation_until": "Free cancellation till ",
  "no_refund_if_cancelled_after": "No refund if cancelled on or after ",
  "cancellation_post_that_will_be_subject_to_a_fee_as_shown_in_the_table": "Cancellation post that will be subject to a fee as shown in the table",
  "hundred_percent_of_the_booking_amount": "100% of the booking amount",
  "Modify your Booking": "Modify your Booking",
  "Have a promo code?": "Have a promo code?",
  "Promotion Applied": "Promotion Applied",
  "Enter Promocode": "Enter Promocode",
  "Apply": "Apply",
  "accessibility_settings": "Accessibility Settings",
  "a11y_large_font": "Large Font",
  "a11y_large_font_desc": "Increase text size across the site",
  "a11y_high_contrast": "High Contrast",
  "a11y_high_contrast_desc": "Black background with white text",
  "a11y_yellow_links": "Yellow Links",
  "a11y_yellow_links_desc": "Highlight all links in yellow",
  "a11y_grayscale": "Grayscale",
  "a11y_grayscale_desc": "Remove all colors from the page",
  "a11y_underline_links": "Underline Links",
  "a11y_underline_links_desc": "Add underline to all links",
  "a11y_reset": "Reset All"
};
